import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'

import DisplayMenu from '../../_common/_icons/DisplayMenu';
import ProfileMenu from '../../_common/_icons/ProfileMenu';
import LogoutMenu from '../../_common/_icons/LogoutMenu';
import BurgerMenu from "../../_common/_icons/BurgerMenu"
import NRTButton from "../../_common/_buttons/Button"


class MCEadMenuBar extends Component {

    state = {
        open: false
    }

    toggleMenuOpen = () => {
        this.setState(state => ({
            open: !state.open
        }))
    }

    openMenu = _.debounce(() => this.setState({open: true}), 400 )
    closeMenu = _.debounce(() => this.setState({open: false}), 400 )



    render() {

        const {open} = this.state
        const {
            page,
            onMenuItemClick,
            logoImgSrc
        } = this.props


        return (
            <div className={'nrt-ead-menu-bar ' + (open ? 'open' : '')}
            >
                <div>

                    <div className="button-ead-menu">
                        <NRTButton onClick={this.toggleMenuOpen}
                                   iconButton
                                   outline
                                   noBorder
                        >
                            <BurgerMenu/>
                        </NRTButton>

                    </div>

                    <div className="menu-logo" onClick={() => onMenuItemClick('home')}>
                        <img src={logoImgSrc}/>
                    </div>
                    <ul >
                        <li className={page === '' ? 'active' : ''} onClick={() => onMenuItemClick('')}
                        >
                            <DisplayMenu/>
                            <a>Meus cursos</a>
                        </li>
                        <li className={page === 'perfil' ? 'active' : ''}
                            onClick={() => onMenuItemClick('perfil')}
                        >
                            <ProfileMenu/>
                            <a>Perfil</a>
                        </li>
                    </ul>
                </div>
                <ul>
                    <li onClick={() => onMenuItemClick('logout')}>
                        <LogoutMenu/>
                        <a>Sair</a>
                    </li>
                </ul>
            </div>
        )
    }
}


MCEadMenuBar.propTypes = {
    page: PropTypes.string,
    onMenuItemClick: PropTypes.func.isRequired,
    logoImgSrc : PropTypes.string.isRequired ,
}

MCEadMenuBar.defaultProps = {}

export default MCEadMenuBar



// WEBPACK FOOTER //
// ./src/components/_ead/MenuBar/index.js